import { NamedNode } from './node';

export class TfCompany extends NamedNode {
    number?: string;
}
